import { render, staticRenderFns } from "./AssistantStepsOverview.vue?vue&type=template&id=bca3656c"
import script from "./AssistantStepsOverview.vue?vue&type=script&lang=ts"
export * from "./AssistantStepsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports